<template>
  <div>
    <a-modal title="点位标签"
             :visible="visible"
             wrapClassName="ponit—tag-modal"
             width="800px"
             @cancel="pointTagModalhandleCancel()">
      <div>
        <a-button type="primary"
                  style="margin-right: 8px;margin-bottom: 16px;"
                  @click="openAddTagModal()">新 增</a-button>
        <a-button @click="isImportModal = true">导 入</a-button>
      </div>
      <a-table :loading="pointTagLoading"
               :columns="pointTagColumns"
               :dataSource="currentPointTagModalData"
               :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          onSelectAll: onPointTagSelectAll,
        }"
               rowKey="id"
               :pagination="{
          total: pointTagTotal,
          pageSize: pointTagPageSize,
          current: pointTagCurrent,
          onChange: onChangePageNum,
        }">
        <div slot="filterDropdown"
             slot-scope="{
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            column,
          }"
             style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)"
                   :placeholder="`搜索${column.title}`"
                   :value="selectedKeys[0]"
                   style="width: 188px; margin-bottom: 8px; display: block;"
                   @change="
              e => setSelectedKeys(e.target.value ? [e.target.value] : [])
            "
                   @pressEnter="
              () => handleSearch(selectedKeys, confirm, column.dataIndex)
            " />
          <a-button type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            搜索
          </a-button>
          <a-button size="small"
                    style="width: 90px"
                    @click="() => handleReset(clearFilters)">
            重置
          </a-button>
        </div>
        <a-icon slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }" />
        <template slot="index"
                  slot-scope="text, record, index">
          {{ tagIndex + index }}
        </template>
        <template slot="status"
                  slot-scope="status">
          <span v-if="status == -1">
            <a-badge status="error" />禁用
          </span>
          <span v-if="status == 0">
            <a-badge status="success" />启用
          </span>
        </template>

        <template slot="pointTagAction"
                  slot-scope="text, record, index">
          <a-popconfirm placement="topRight"
                        ok-text="确 定"
                        cancel-text="取 消"
                        @confirm="deleteTag(record, index)">
            <template slot="title">
              <p>你确定要删除该标签吗？</p>
            </template>
            <a href="#">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
      <div v-if="currentPointTagModalData.length > 0"
           class="point-tag-table-bottom">
        <a-button @click="deleteTags">删除所选</a-button>
      </div>
      <template slot="footer">
        <a-button key="back"
                  @click="pointTagModalhandleCancel">
          关 闭
        </a-button>
      </template>
    </a-modal>

    <AddPointTagsModle v-if="isAddTagModal"
                       :isAddTagModalVisible.sync="isAddTagModal"
                       :pointTagModalId="pointTagModalId"
                       @upDateChange="changeHandler" />
    <!-- 导入弹窗 -->
    <a-modal v-if="isImportModal"
             title="标签导入"
             wrapClassName="import-modal"
             :visible="isImportModal"
             width="448px"
             @cancel="importModalhandleCancel"
             @ok="importModalhandleOk"
             okText="确定">
      <div class="first-step">
        <p class="step-title">第一步：下载标签导入模板</p>
        <div class="export_step_box">
          <img src="@/assets/images/export.png"
               alt="" />
          QFAD标签导入模板
          <a :href="downUrl"
             download="标签导入模板.xlsx"
             class="downloag_btn"
             @click="dowmLoadFun">点击下载
            <a-icon type="arrow-down" />
          </a>
        </div>
        <div class="second-step">
          <p class="step-title">第二步：上传编辑好的Excle表格</p>
          <a-upload-dragger accept=".xls,.xlsx"
                            :fileList="fileList"
                            :beforeUpload="beforeUploadFun"
                            :multiple="true"
                            @change="handleChange">
            <img class="upload_img"
                 src="../../assets/images/export.png"
                 alt="" />
            <div class="upload_text">点击或将文件拖拽到这里上传</div>
          </a-upload-dragger>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import api from '../../commomFun/api.js'
import { baseURL } from '../../utils/config.js'
import AddPointTagsModle from './AddPointTagsModle'
// import { baseURL } from '@/utils/config.js'

export default {
  components: {
    AddPointTagsModle,
  },
  props: {
    visible: Boolean,
    pointTagModalId: Number,
  },
  data() {
    return {
      //点位标签弹窗行数据格式
      pointTagModalData: [],
      currentPointTagModalData: [],
      pointTagLoading: false,
      pointTagColumns: [
        {
          title: '序号',
          key: 'index',
          width: 120,
          scopedSlots: {
            customRender: 'index',
          },
        },
        {
          title: '所属标签组',
          dataIndex: 'groupName',
          key: 'groupName',
          align: 'left',
          ellipsis:true,
          width: 120,

          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.groupName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          },
        },
        {
          title: '标签名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis:true,
          width: 120,

          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.name.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          },
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,

          key: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          filters: [
            { text: '启用', value: '0' },
            { text: '禁用', value: '-1' },
          ],
          filterMultiple: false,
          onFilter: (value, record) => (record.status + "") === value,
        },
        {
          title: '操作',
          dataIndex: 'pointTagAction',
          key: 'pointTagAction',
          align: 'left',
          width: 80,
          scopedSlots: {
            customRender: 'pointTagAction',
          },
        },
      ],
      // 点位标签弹窗数据
      // 点位标签选择的行
      selectedRowKeys: [],
      //点位标签弹分页
      // pointTagInfo:
      pointTagTotal: 0,
      pointTagPageSize: 10,
      pointTagCurrent: 1,
      // pointTagconfirmLoading: false,
      //点位资源搜索
      searchText: '',
      searchedColumn: '',

      //新增标签弹窗 是否显示
      isAddTagModal: false,
      //新增标签 穿梭框左边列表
      addTagList: [],
      currentAddTagList: [], //用于全选所有
      targetKeys: [],
      currentTargetKeys: [],
      addTagLeftColumns: [
        {
          dataIndex: 'title',
          title: '所属标签组',
          width: 120,
        },
        {
          dataIndex: 'description',
          title: '标签',
          width: 120,
          scopedSlots: {
            customRender: 'description',
          },
        },
      ],
      addTagRightColumns: [
        {
          dataIndex: 'title',
          title: '所属标签组',
        },
        {
          dataIndex: 'description',
          title: '标签',
          scopedSlots: {
            customRender: 'description',
          },
        },
      ],
      //导入弹框
      isImportModal: false,

      downUrl: '',
      fileList: [], //待上传的文件
    }
  },
  created() {
    this.downUrl = baseURL + '/importTemplate/QFAD-点位标签导入模板.xlsx'
    this.getPointTagDate()
  },
  computed: {
    tagIndex: function () {
      return (this.pointTagCurrent - 1) * this.pointTagPageSize + 1
    },
  },
  watch: {},
  methods: {
    //获取点位资源标签
    getPointTagDate() {
      this.pointTagLoading = true
      let params = {
        pageSize: 10000,
        pageNum: 1,
        pointId: this.pointTagModalId,
      }
      api
        .getApi(`/tags`, params)
        .then((res) => {
          if (res.data.code == 200) {
            this.pointTagModalData = [...res.data.data.list]
            this.currentPointTagModalData = [...res.data.data.list]
          } else {
            this.$message.error(res.data.msg || '获取当前点位资源失败')
          }
        })
        .catch((e) => {
          this.$message.error('获取当前点位资源失败')
        })
        .finally(() => {
          this.pointTagLoading = false
        })
    },
    getPointTagDatePromise() {
      return new Promise((resolve, reject) => {
        this.pointTagLoading = true
        let params = {
          pageSize: 10000,
          pageNum: 1,
          pointId: this.pointTagModalId,
        }
        api
          .getApi(`/tags`, params)
          .then((res) => {
            if (res.data.code == 200) {
              this.pointTagModalData = [...res.data.data.list]
              this.currentPointTagModalData = [...res.data.data.list]
            } else {
              this.$message.error(res.data.msg || '获取当前点位资源失败')
            }
            resolve()
          })
          .catch((e) => {
            this.$message.error('获取当前点位资源失败')
            reject()
          })
          .finally(() => {
            this.pointTagLoading = false
          })
      })
    },
    /// 点位资源
    //点位标签弹框 取消
    pointTagModalhandleCancel() {
      // this.isPointTagModal = false
      this.$emit('update:visible', false)
    },
    //点位资源 单选
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    //点位资源 重写全选
    onPointTagSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRowKeys = [
          ...this.currentPointTagModalData.map((item) => item.id),
        ]
      } else {
        this.selectedRowKeys = []
      }
    },

    //deleteTag 删除标签
    deleteTag(record) {
      this.deleteTagsApi({
        pointId: this.pointTagModalId,
        tagIds: [record.id],
      })
    },
    //  批量删除标签
    deleteTags() {
      let that = this
      if (that.selectedRowKeys.length <= 0) {
        return this.$message.warning('请选择需要删除的标签')
      }
      this.$confirm({
        title: '确认删除所选标签吗?',
        content: (h) => (
          <div style="color:rgba(0, 0, 0, 0.65);fontSize:14px">
            删除标签后，将不可恢复，请谨慎操作
          </div>
        ),
        onOk() {
          that.deleteTagsApi({
            pointId: that.pointTagModalId,
            tagIds: that.selectedRowKeys.map(Number),
          })
        },
        onCancel() {},
        class: 'test',
      })
    },

    deleteTagsApi(deleteTags) {
      api
        .deleteApi('/tag/pointTag', deleteTags)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success('删除成功')
            this.getPointTagDate()
            this.$emit('changeHandler')
            //删除后改变的值selectedRowKeys
            this.deleteSelectTag(deleteTags.tagIds)
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        })
        .catch((e) => {
          this.$message.error('删除失败')
        })
    },
    deleteSelectTag(deleteTags) {
      deleteTags.forEach((item) => {
        const index = this.selectedRowKeys.findIndex((i) => {
          return i.key == item
        })
        this.selectedRowKeys.splice(index, 1)
      })
    },
    //切换页码
    onChangePageNum(page, pageSize) {
      this.pointTagCurrent = page
    },
    //点位资源搜索
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
      this.onSearchFilter(this.searchText, dataIndex)
    },

    onSearchFilter(value, type) {
      this.currentPointTagModalData = this.currentPointTagModalData.filter(
        (item) => {
          let flag = item[type]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
          if (flag) {
            return item
          }
        }
      )
    },
    //重置
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
      this.currentPointTagModalData = this.pointTagModalData
    },
    async changeHandler() {
      this.$emit('changeHandler')
      await this.getPointTagDatePromise()
      //将上面请求回来的数据，筛选掉选择里没有的
      // 目前选择的数据 this.selectedRowKeys 里面会有多
      //删除之后的数据 this.currentPointTagModalData
      this.changeSelectedTags()
    },

    changeSelectedTags() {
      const data = []
      this.selectedRowKeys.forEach((rowKey) => {
        const currentItem = this.currentPointTagModalData.find(
          (item) => item.id == rowKey
        )
        if (currentItem) {
          data.push(currentItem.id)
        }
      })
      this.selectedRowKeys = [...data]
    },
    // ///  新增标签弹窗
    // //点位标签 新增标签弹窗
    openAddTagModal() {
      this.isAddTagModal = true
    },

    //导入弹框关闭
    importModalhandleCancel() {
      this.isImportModal = false
    },

    handleChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        // this.$message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        // this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    //提交
    importModalhandleOk() {
      const { fileList } = this
      if (fileList.length === 0) {
        this.$message.warning('您还没有上传文件哦~')
        return
      }
      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append('file', file)
      })
      // this.uploading = true;
      formData.append('pointId', this.pointTagModalId)
      api
        .postApi_file(`/tag/importPointTags`, formData)
        .then((res) => {
          if (res.data.code == 200) {
            let resData = res.data.data
            this.isMediaSourceModal = false
            const h = this.$createElement
            this.$success({
              title: '导入标签完成',
              content: h('div', {}, [
                h('span', '已成功导入 '),
                h(
                  'span',
                  { style: { color: 'rgba(24, 144, 255, 1)' } },
                  resData.successSize || '0'
                ),
                h('span', ' 条，重复 '),
                h(
                  'span',
                  { style: { color: 'rgba(250, 173, 20, 1)' } },
                  resData.repeatSize || '0'
                ),
                h('span', ' 条，失败 '),
                h(
                  'span',
                  { style: { color: 'rgba(245, 34, 45, 1)' } },
                  resData.failSize || '0'
                ),
                h('span', ' 条'),
              ]),
              onOk() {},
            })
            this.getPointTagDate()
            this.$emit('changeHandler')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((e) => {
          console.error('导入点位标签', e)
        })
        .finally(() => {
          this.importModalhandleCancel()
          this.fileList = []
        })
    },
    // 导入模版下载, 阻止冒泡事件
    dowmLoadFun(event) {
      event.stopPropagation()
    },

    // 上传文件前
    beforeUploadFun(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .ponit—tag-modal {
  .ant-modal-body {
    position: relative;
  }
  .point-tag-table-bottom {
    position: absolute;
    bottom: 40px;
  }
  .ant-table td {
    white-space: nowrap;
  }
}

/deep/ .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 12px 12px;
}

.upload_img {
  width: 26px;
  height: 26px;
}

/deep/ .import-modal {
  .step-title {
    margin-bottom: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }

  .export_step_box {
    // border: 1px dashed rgba(218, 218, 218, 1);
    margin-bottom: 24px;
    border: 1px solid rgba(218, 218, 218, 1);
    border-radius: 4px;
    padding: 12px 18px;
    color: rgba(102, 102, 102, 1);
    font-size: 15px;
    position: relative;
    &:hover {
      cursor: pointer;
      border-color: #409eff;
    }
    img {
      margin-right: 8px;
      width: 26px;
      height: 26px;
      vertical-align: middle;
    }
    .downloag_btn {
      position: absolute;
      right: 18px;
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      color: rgba(102, 102, 102, 1);
    }
  }
  .second-step {
    .upload_img {
      margin: 16px 0 12px 0;
    }
    .upload_text {
      margin-bottom: 16px;
    }
  }
}
</style>
